// extracted by mini-css-extract-plugin
export default {"comment":"styles_comment__S4odX","tooltipChild":"styles_tooltipChild__ouSNr","imageIconColumn":"styles_imageIconColumn__UbHss"};